<template>
  <div class="container-search" @mouseleave="onMouseleave">
    <div class="wrap">
      <div class="standard" v-show="Boolean(data.standardSearchDisplay)">
        <div class="searchbox">
          <input type="text" placeholder="つぶやきをさがす" v-model="data.keywords">
          <button id="searchbutton" type="submit" @click="search">検索</button>
        </div>
        <button class="advancedbutton" type="submit" @click="toggleStandardSearchDisplay">詳細検索</button>
      </div>
      <div class="advanced" v-show="!Boolean(data.standardSearchDisplay)">
        <div class="searchbox">
          <input type="text" placeholder="キーワードを入力" v-model="data.keywords">
        </div>
        <div class="settings">
          <div class="selectwrap">
            <select name="a" v-model="data.circleId" @focus="toggleFocusCircleSelectFlg" @blur="toggleFocusCircleSelectFlg">
              <option value="" style="display:block;">サークル</option>
              <option v-for="(circle, index) in data.circles" v-bind:value="circle.id" :key="index">{{circle.circle_name}}</option>
            </select>
          </div>
          <div class="selectwrap">
            <select name="b" v-model="data.accountId" @focus="toggleAccountSelectFlg" @blur="toggleAccountSelectFlg">
              <option value="" style="display:block;">つぶやいた人</option>
              <option v-for="(account, index) in data.destinations" v-bind:value="account.id" :key="index">{{account.last_name + account.first_name}}</option>
            </select>
          </div>
          <div class="selectwrap">
            <select name="c" v-model="data.hashtagId" @focus="toggleHashtagSelectFlg" @blur="toggleHashtagSelectFlg">
              <option value="" style="display:block;">話題</option>
              <option v-for="(hashtag, index) in data.hashtags" v-bind:value="hashtag.id" :key="index">{{hashtag.name}}</option>
            </select>
          </div>
          <button id="searchbutton" type="submit" @click="search">検索</button>
        </div>
        <button class="backbutton" type="submit" @click="toggleStandardSearchDisplay">フリーワードに戻る</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import axios from 'axios'
import Global from '@/js/constant.js'
import { useRouter} from 'vue-router'
import { useStore } from 'vuex'
import { useToast } from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

import { computed, onMounted, reactive, watch } from "vue"

const $router = useRouter()
const $store = useStore()
const $toast = useToast()

const data = reactive({
  keywords     : '',
  circleId     : '',
  officialCircle : null,
  accountId    : '',
  hashtagId    : '',
  circles      : null,
  destinations : null,
  allDestinations:null,
  hashtags     : null,
  searchStates : [],
  standardSearchDisplay : true,
  advancedSearchDisplay : false,
  focusCircleSelect: false,
  focusAccountSelect: false,
  focusHashtagSelect: false,
})
// computed
// mapState
const account = computed(() => $store.state.core.account)
const circles = computed(() => $store.state.circles.circles)
const keywordSearchEntries = computed(() => $store.state.keywordSearch.keywordSearchEntries)

// mapMutations
const setKeywords = (val) => $store.commit('setKeywords', val)
const setKeywordSearchEntries = (val) => $store.commit('setKeywordSearchEntries', val)
const setKeywordSearchContainerDisplay = (val) => $store.commit('setKeywordSearchContainerDisplay', val)

// watch
watch(circles, (newCircles) => {
  data.circles = newCircles
  // console.dir(newCircles)
})

watch(() => data.circleId, (newCircleId) => {
  let circle = data.circles.filter(c => c.id == newCircleId)
  data.officialCircle = circle[0].publish
  data.destinations = circle[0].members
  data.hashtags = circle[0].hashtags
})

onMounted(() => {
  data.circles = circles.value
})

// methods
const search = () => {
  if (!data.keywords) {
    $toast.error('please input keyword')
    return
  }
  setKeywords(data.keywords)
  setKeywordSearchEntries([])
  data.searchStates = []

  $router.push( { path : '/keyword-search'}, () => {} )

  setKeywordSearchContainerDisplay(false)
  /*
    キーワードを	
    keyword_search_division_id : {
      entry : 1, // つぶやきからキーワードに合致するもの
      account_name : 2, // アカウント名からキーワードに合致するもの
      circle_name : 3, // サークル名からキーワードに合致するもの
      hashtag_name : 4 // ハッシュタグ名からキーワードに合致するもの
    }
    単位で並行的に検索を実行する
    そのためinitSearchStatesにて
    並行処理でも管理できるようにオブジェクトの配列を生成
  */
  initSearchStates()

  for (let idx in data.searchStates) {
    asyncCallApi(idx)
  }

  //全てのstatesがcompletedになるまで待つ
  let filteredStates = []
  do {
    filteredStates = data.searchStates.filter(item => item.completed == false)
   } while (filteredStates.length > 0)
}

const asyncCallApi = (idx) => {
  let row = data.searchStates[idx]
  let params = {
    entry_division_id: row.entry_division_id,
    keyword_search_division_id: row.keyword_search_division_id,
    keyword: row.keyword,
    login_account_id: row.login_account_id,
  }
  if (data.circleId) params['circle_id'] = data.circleId
  if (data.accountId) params['account_id'] = data.accountId
  if (data.hashtagId) params['hashtag_id'] = data.hashtagId 
  axios.post(Global.url.api_keyword_search, params)
  .then(res => {
    if (res.data.status == Global.api_status.success) {
      //新規entryのみ絞り込み
      let newEntries = []
      res.data.entries.forEach(entry => {
        let duplicateEntries = keywordSearchEntries.value.filter(item => item.id == entry.id)
        if (duplicateEntries.length == 0) {
          newEntries.push(entry)
        }
      });
      setKeywordSearchEntries(newEntries)
      return
    }
  })
  .catch(error => {
    $toast.error('client error')
    console.dir(error)
  })
  .finally(()=>{
    row.completed = true
  })
}

const initSearchStates =  () => {
  // eslint-disable-next-line
  let _keywords = data.keywords.replace(/　/g," ");
  let keywordArrays = _keywords.split(' ')
  for (let idx in keywordArrays) {
    if (keywordArrays[idx].trim() == '') continue
    for (let key in Global.keyword_search_division_id) {
      data.searchStates.push({
        'entry_division_id': Global.entry_division_id.keyword_search,
        'keyword_search_division_id': Global.keyword_search_division_id[key],
        'keyword': keywordArrays[idx],
        'login_account_id': account.value && account.value.id,
        'completed': false 
      })
    }
  }
}
const toggleFocusCircleSelectFlg= () => {
  data.focusCircleSelect = !data.focusCircleSelect
}
const toggleAccountSelectFlg= () => {
  data.focusAccountSelect = !data.focusAccountSelect
}
const toggleHashtagSelectFlg= () => {
  data.focusHashtagSelect = !data.focusHashtagSelect
}
const toggleStandardSearchDisplay = () => {
  data.standardSearchDisplay = !data.standardSearchDisplay
}
const onMouseleave = () => {
  if (data.focusCircleSelect || data.focusAccountSelect || data.focusHashtagSelect) return
  setKeywordSearchContainerDisplay(false)
}
</script>